import Axios from '../services/index'
import * as React from 'react'
import { Link } from 'react-router-dom'

interface IUDTC {
    id: Int32Array
}

interface ITrainingNameId {
    Name: string,
    Id: Int32Array,
}

//This component display the training a user already own
export const UserDetailTrainingCard: React.FunctionComponent<IUDTC> = (props) => {

    const currentToken = localStorage.getItem('access_token')
    const [trainingNameId, setTrainingNameId] = React.useState<ITrainingNameId>()


    React.useEffect(() => {
                Axios.get(`https://LaurenceBrun.eu.pythonanywhere.com/training/${props.id}/`, {
                    headers: {
                        "Authorization": `Bearer ${currentToken}`
                    }
                })
                .then(function(response: any) {
                    setTrainingNameId({
                        Name: response.data.title, 
                        Id: response.data.id})
                })
                .catch(function(error: any) {
                    alert("Une erreur est survenue ! Veuillez réessayer")
                })
    }, [])

    if (trainingNameId) {
        return(
            <ul>
                <Link to={`/training/${props.id}`}><li className="ConnectButton Connexion">{trainingNameId.Name}</li></Link>
            </ul>
        )
    }
    else {
        return(
            <div></div>
        )
    }
    
}